<script setup>
import { ref } from 'vue';
import { useConfiguratorStore } from '../../stores/configurator';
import Icon from '../Icon.vue';
import Loader from '../Loader.vue';
import { sendConfiguratorEvent } from '../../common/event-tracking.js';
import { useUiStore } from '../../stores/ui.js';
import Altcha from '../Form/Altcha.vue';

const configurationStore = useConfiguratorStore();
const uiStore = useUiStore();

const isLoading = ref(false);
const error = ref(null);
const success = ref(false);
const email = ref('');
const terms = ref(false);
const altcha = ref('');

async function saveConfig() {
    try {
        sendConfiguratorEvent('save_config')

        if(isLoading.value){
            return;
        }

        isLoading.value = true

        const response = await fetch('/configurator/save', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email.value,
                terms: terms.value,
                hash: configurationStore.configHash,
                configuration: configurationStore.jsonSerializedConfiguration,
                altcha: altcha.value,
            })
        })
        const json = await response.json();

        if(json.success){
            configurationStore.configHash = json.data.hash;
            error.value = null
            success.value = true;
        }else if(json.error){
            error.value = data.error
        }

    } catch (error) {
        error.value = "Service unavailable";
    }

    isLoading.value = false;
}
</script>

<template>
    <form
        @submit.prevent="saveConfig()"
        class="tw-absolute tw-text-white tw-bottom-20 tw-max-w-[416px] md:tw-bottom-24 lg:tw-bottom-28 tw-left-4 md:tw-left-6 lg:tw-left-8 tw-right-4 md:tw-right-6 lg:tw-right-8 tw-rounded-t-lg tw-rounded-br-lg tw-bg-gray-900 tw-py-8 tw-px-6 md:tw-pt-12 tw-transition tw-ease-in-out tw-duration-300"
        :class="uiStore.showSaveConfig ? 'tw-opacity-100 tw-translate-y-0 sm:tw-scale-100 tw-pointer-events-auto' : 'tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95 tw-pointer-events-none'"
    >
        <div
            class="tw-text-brand-500 tw-absolute tw-top-6 tw-right-6 tw-cursor-pointer"
            @click.prevent="uiStore.showSaveConfig = false; success = false;"
        >
            <Icon name="close" class="tw-size-6" />
        </div>

        <div class="tw-text-20 tw-font-medium tw-mb-2" v-t="`website.configurator.save_config`"></div>

        <div class="tw-mb-4" v-t="`website.configurator.save_config_desc`"></div>

        <div class="tw-mt-6">
            <div
                class="tw-bg-red tw-text-white tw-rounded-sm tw-p-4 tw-text-sm tw-mb-4"
                v-if="error"
                v-text="error"
            >
            </div>

            <div v-if="!configurationStore.configHash" class="tw-mb-4">
                <div class="form-group">
                    <label for="save_config_email" class="tw-block tw-mb-2" v-t="`website.configurator.save_save_config_email`"></label>

                    <input
                        type="email"
                        id="save_config_email"
                        class="form-control tw-text-black tw-w-full tw-rounded-sm tw-outline-brand-500 tw-ring-none"
                        v-model="email"
                    />
                </div>

                <div class="form-group checkbox tw-mt-4">
                    <input
                        type="checkbox"
                        id="save_config_terms"
                        v-model="terms"
                    />

                    <label for="save_config_terms" v-html="$t('website.configurator.save_config_terms')"></label>
                </div>
            </div>

            <div class="tw-mb-4">
                <Altcha
                    v-model="altcha"
                />
            </div>

            <div v-if="configurationStore.configHash && success">
                <div class="tw-text-base" v-t="`website.configurator.save_config_stored_successfully`"></div>
            </div>
        </div>

        <div
            class="tw-flex tw-items-center tw-gap-x-3 tw-mt-6"
            v-if="!success"
        >
            <button
                class="btn btn-configurator primary"
                type="submit"
                :disabled="(configurationStore.isImageLoading || isLoading || !terms || !email || altcha.length === 0)"
                v-t="configurationStore.configHash ? 'website.configurator.save_config' : 'website.configurator.send_config'"
            >
            </button>

            <div
                class="relative tw-w-10 tw-h-10 tw-transition tw-ease-in-out tw-duration-300 tw-pointer-events-none"
                :class="isLoading ? 'tw-opacity-100' : 'tw-opacity-0'"
            >
                <Loader class="tw-scale-50 tw-text-brand-500 tw-absolute tw--translate-x-1/2 tw--translate-y-1/2 tw-top-1/2 tw-left-1/2" />
            </div>
        </div>

        <div class="tw-absolute tw-bottom-0 tw-left-1 tw-w-5 tw-h-5 tw-translate-y-1/2 tw-bg-gray-900 tw-rounded-bl-sm tw-transform tw--rotate-45 tw-z-10"></div>
    </form>
</template>